import { FC } from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiSpacer, EuiTitle } from '@elastic/eui'

import { AIPlanBlueprintPreview } from 'api/entities/AIPlanBlueprintPreview'
import AIPlannerMarkdownRenderer from 'pages/MasterCampaignPlanPage/new/components/AIPlannerMarkdownRenderer'

import ReadOnlyStructuredMarketAnalysis from 'pages/AIPlanPage/components/ReadOnlyStructuredMarketAnalysis'

interface AIPlanBlueprintMarketAnalysisProps {
  blueprint: AIPlanBlueprintPreview
}

const AIPlanBlueprintMarketAnalysis: FC<AIPlanBlueprintMarketAnalysisProps> = ({ blueprint }) => {
  const section = blueprint.marketAnalysisSection

  const introductionTitle = section?.introduction?.title || 'Market Analysis & Strategy'
  const introductionContent = section?.introduction?.content || `## ${blueprint.companyName}\n\n---`

  return (
    <>
      <EuiHorizontalRule />

      {section?.introduction?.hideAll !== true && (
        <>
          <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiTitle size='m'>
                <h3>{introductionTitle}</h3>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
          <div style={{ paddingTop: 24 }}>
            <AIPlannerMarkdownRenderer content={introductionContent} />
          </div>
          <EuiSpacer size='xl' />
        </>
      )}

      <ReadOnlyStructuredMarketAnalysis marketAnalysis={blueprint.marketAnalysis} marketAnalysisSection={section} />
    </>
  )
}

export default AIPlanBlueprintMarketAnalysis
